import React, { Component } from 'react';
import NoAvailableComponent from '../FloatingSideComponents/NoAvailableComponent'
import { noAvailableSVG } from '../../../Images/NoAvailableSVG';
import { Singleton } from '../../../js/Singleton';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { DRAGGABLE_WINDOWS } from '../../../constants';
import { Logger } from '../../../js/helpers/Logger';

export default class NoAvailableExpanded extends Component {
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    Logger.Trace("[NoAvailableExpanded] No Available Constructor => ");
  }
  componentWillUnmount() {
    Logger.Trace("[NoAvailableExpanded][componentWillUnmount] Removing No Available => ");
  }
  render() {
    return (
      <div className={"WorkBarExpanded " + (this.sharedData.getWindowExpandedActive() !== DRAGGABLE_WINDOWS.NO_AVAILABLE ? "height0" : "")}
        key="noAvailableExpanded">
        {CUSTOM_COMPONENTS["sideBarHeader"](noAvailableSVG, this.language.getText("GUICommonMenudisable"))}
        <NoAvailableComponent floating={false} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/workSpace/ExpandedBar/NoAvailableExpanded.jsx